import React, { useEffect, useRef, useState } from "react";
import { Formik, Form, Field } from "formik";
import Select from "react-select";
import { CorporationStore } from "../corporation_master/CorporationStore";
import { DashBoardStore } from "./DashBoardStore";
import CountUp from "react-countup";
import DashboardCardLoader from "../../Common/DashboardCardLoader/DashboardCardLoader";
import KMLmap from "./googlemap/KMLmap";

const getStartOfCurrentDateTime = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const SatsDashboard = () => {
  const { fetchUserCorporations, UserCorporations } = CorporationStore();
  const {
    fetchSATDashboardDetails,
    SATDashboardDetails,
    isSATDashboardLoading,
  } = DashBoardStore();
  const [hoveredCard, setHoveredCard] = useState(null);
  const [currentDateTime, setCurrentDateTime] = useState(getStartOfCurrentDateTime());
  
  useEffect(() => {
    setCurrentDateTime(getStartOfCurrentDateTime());
    fetchUserCorporations();
    fetchSATDashboardDetails({
      startDate: getStartOfCurrentDateTime(),
      corporationIds: [],
    });
  }, []);

  const corporationOptions = UserCorporations.map((corp) => ({
    value: corp.corporationId,
    label: corp.corporationName,
  }));

  const initialValues = {
    startDate: currentDateTime,
  
    corporationIds: [],
  };
  const onSubmit = (values) => {
    console.log("Form values on submit:", values);
    fetchSATDashboardDetails(values);
  };

  const SATCards = [
    {
      title: "SAT Masters",
      value:
        SATDashboardDetails?.length > 0 ? SATDashboardDetails[0].activeVehicle : 0,
      accent: "#4A90D9",
    },
    {
      title: "SAT Deployment",
      value:
        SATDashboardDetails?.length > 0 ? SATDashboardDetails[0].reportedAtWard : 0,
      accent: "#27AE60",
    },
    {
      title: "SAT Reported at TS/SCTP",
      value:
        SATDashboardDetails?.length > 0
          ? SATDashboardDetails[0].reportedAtTS
          : 0,
      accent: "#E67E22",
    },
  ];

  return (
    <div style={{ width: "100%" }}>
      <div className="content">
        <div className="page-content">
          <h4 className="text-start mb-3">SCVs Dashboard</h4>
          <div className="card">
            <div className="card-body">
              <div className="row" style={{ textAlign: "justify" }}>
                <div className="col-md-12">
                  <Formik initialValues={initialValues} onSubmit={onSubmit} enableReinitialize={true}>
                    {({ values, setFieldValue }) => (
                      <Form>
                        <div className="row" style={{ textAlign: "justify" }}>
                          <div className="col-md-3">
                            <div className="form-group">
                              <label htmlFor="startDate">Date</label>
                              <Field
                                type="date"
                                className="form-control"
                                id="startDate"
                                name="startDate"
                                style={{
                                  backgroundColor: "#FFF",
                                  borderRadius: "0px",
                                }}
                                max={getStartOfCurrentDateTime()}
                              />
                            </div>
                          </div>
                         
                          <div className="col-md-3">
                            <div className="form-group">
                              <label htmlFor="corporationIds">
                                Corporation Id
                              </label>
                              <Select
                                inputId="corporationIds"
                                isMulti
                                options={corporationOptions}
                                value={corporationOptions.filter((opt) =>
                                  values.corporationIds.includes(opt.value),
                                )}
                                onChange={(selected) =>
                                  setFieldValue(
                                    "corporationIds",
                                    (selected || []).map((c) => c.value),
                                  )
                                }
                                placeholder="Select Corporation(s)"
                                styles={{
                                  control: (base, state) => ({
                                    ...base,
                                    borderRadius: "0px",
                                    backgroundColor: "#ececec",
                                    border: "1px solid #dee2e6",
                                    boxShadow: state.isFocused
                                      ? "0 0 0 0.2rem rgba(0,123,255,0.25)"
                                      : "none",
                                    borderColor: state.isFocused
                                      ? "#80bdff"
                                      : "#ced4da",
                                    minHeight: "38px",
                                    fontSize: "1rem",
                                    "&:hover": { borderColor: "#ced4da" },
                                  }),
                                  valueContainer: (base) => ({
                                    ...base,
                                    padding: "0px 8px",
                                  }),
                                  placeholder: (base) => ({
                                    ...base,
                                    color: "#6c757d",
                                    fontSize: "1rem",
                                    marginLeft: "6px",
                                  }),
                                  indicatorSeparator: (base) => ({
                                    ...base,
                                    backgroundColor: "#fff",
                                  }),
                                  dropdownIndicator: (base) => ({
                                    ...base,
                                    padding: "6px",
                                    color: "#6c757d",
                                  }),
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-md-3 mt-4">
                            <button type="submit" className="btn search-swm">
                              Search
                            </button>
                          </div>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </div>
              </div>
            </div>
          </div>

          {isSATDashboardLoading ? (
            <DashboardCardLoader count={3} />
          ) : null}

          <div className="row mt-3 g-3">
            {!isSATDashboardLoading && SATCards.map((card, index) => {
              const isHovered = hoveredCard === index;
              return (
                <div className="col-md-4" key={index}>
                  <div
                    className="card border-0"
                    onMouseEnter={() => setHoveredCard(index)}
                    onMouseLeave={() => setHoveredCard(null)}
                    style={{
                      borderRadius: "12px",
                      background: "#f8f9fa",
                      boxShadow: isHovered
                        ? "0 12px 28px rgba(0,0,0,0.15)"
                        : "0 2px 8px rgba(0,0,0,0.08)",
                      transform: isHovered
                        ? "translateY(-6px) scale(1.02)"
                        : "translateY(0) scale(1)",
                      transition: "all 0.25s ease",
                      cursor: "pointer",
                    }}
                  >
                    <div className="card-body" style={{ padding: "20px 24px" }}>
                      <div
                        style={{
                          width: "40px",
                          height: "4px",
                          backgroundColor: card.accent,
                          borderRadius: "2px",
                          marginBottom: "14px",
                        }}
                      />
                      <p
                        className="mb-1"
                        style={{
                          fontSize: "13px",
                          color: "#6c757d",
                          fontWeight: 500,
                          textTransform: "uppercase",
                          letterSpacing: "0.5px",
                        }}
                      >
                        {card.title}
                      </p>
                      <h3
                        className="mb-0"
                        style={{
                          color: card.accent,
                          fontWeight: 700,
                        }}
                      >
                        <CountUp end={card.value} duration={3} />
                      </h3>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-md-12 m-auto">
            <div className="card">
              <KMLmap />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SatsDashboard;
